import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd543498"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product_service" }
const _hoisted_2 = { class: "service" }
const _hoisted_3 = { class: "principally" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "产品服务")
], -1))
const _hoisted_5 = { class: "switch-tab-scroll-item" }
const _hoisted_6 = { class: "card-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "principally content" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "en" }
const _hoisted_12 = {
  key: 0,
  class: "msg"
}
const _hoisted_13 = { class: "apiList" }
const _hoisted_14 = { class: "api_title" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "dian" }, null, -1))
const _hoisted_18 = {
  key: 2,
  class: "btn"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 了解更多", -1))

import ksh_gery from "@/static/Home/productService/grey/ksh.png";
import ksh_color from "@/static/Home/productService/color/ksh.png";
import slgc_gery from "@/static/Home/productService/grey/slgc.png";
import slgc_color from "@/static/Home/productService/color/slgc.png";

import yth_gery from "@/static/Home/productService/grey/yth.png";
import aiot_gery from "@/static/Home/productService/grey/aiot.png";
import jqr_gery from "@/static/Home/productService/grey/jqr.png";
import qxt_gery from "@/static/Home/productService/grey/qxt.png";
import qxsj_gery from "@/static/Home/productService/grey/qxsj.png";

import yth_color from "@/static/Home/productService/color/yth.png";
import aiot_color from "@/static/Home/productService/color/aiot.png";
import jqr_color from "@/static/Home/productService/color/jqr.png";
import qxt_color from "@/static/Home/productService/color/qxt.png";
import qxsj_color from "@/static/Home/productService/color/qxsj.png";

import eSwitch from "@/components/eSwitch.vue";

import shikuang from "@/static/dataApi/gray/shikuang.png";
import yubao from "@/static/dataApi/gray/yubao.png";
import yujing from "@/static/dataApi/gray/yujing.png";
import kongzhi from "@/static/dataApi/gray/kongzhi.png";
import zhishu from "@/static/dataApi/gray/zhishu.png";
import haiyang from "@/static/dataApi/gray/haiyang.png";

import { ref } from "vue";
import { useRouter } from "vue-router";
type scaleProps = {
  icon: string;
  icon2: string;
  title: string;
  en?: string;
  msg: string;
  path: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'productService',
  setup(__props) {

const scaleList = ref<scaleProps[]>();
const cardIndex = ref(0);
const apiList = ref();
const router = useRouter();
scaleList.value = [
  // {
  //   icon: ksh_gery,
  //   icon2: ksh_color,
  //   title: "气象可视化",
  //   msg: "相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案",
  //   path: "/productService/weatherVisual",
  // },
  {
    icon: yth_gery,
    icon2: yth_color,
    title: "气象预报预警平台",
    en: "WARNING PLATFORM",
    msg: "基于城市、站点、格点级别数据，推出面向各行业的精细化气象预报预警平台，通过可视化的气象产品以及创新迭代的灾害预测种类、级别，旨在为行业客户提供丰富的气象服务内容，帮助其防灾减灾，降低成本损失，提升服务质量。",
    path: "/productService/integrationPlatform",
  },
  {
    icon: qxsj_gery,
    icon2: qxsj_color,
    title: "气象数据产品",
    en: "METEOROLOGICAL DATA",
    msg: "暂定",
    path: "/dataProduct/0/00",
  },
  // {
  //   icon: slgc_gery,
  //   icon2: slgc_color,
  //   title: "水电站监管平台",
  //   msg: "相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案相关文案",
  //   path: "/productService/waterConservancy",
  // },
  {
    icon: aiot_gery,
    icon2: aiot_color,
    title: "AIoT智能观测台",
    en: "OBSERVATION SYSTEM",
    msg: "AIoT智能观测台采用云、边、端架构，提出了“智慧硬件+核心平台+智能应用”的融合解决方案。集多信道通信、远程控制于一体，可实现用一台设备就能够同时满足数据采集、视频识别、设备管理等多种业务叠加的功能。",
    path: "/productService/AIoT",
  },
  {
    icon: jqr_gery,
    icon2: jqr_color,
    title: "MC机器人",
    en: "WEATHER TRIGGER",
    msg: "基于多维专业天气数据，设置对应地区预警天气阈值。当天气变化超过预警条件时，终端实时接收预警通知，助力更好地预防和应对恶劣天气。",
    path: "/productService/robot",
  },
  {
    icon: qxt_gery,
    icon2: qxt_color,
    title: "HISTORY气象台",
    en: "METEOROLOGICAL OBSERVATORY",
    msg: "HISTORY气象台为行业用户提供历史气候趋势分析及重点要素统计分析服务，包含多种气象要素图表、分析文档、统计结果，如风速玫瑰图、降水柱状图、气温趋势图，风速统计表等，亦可快速响应不同客户的历史数据需求，提升服务效率，降低人工成本。",
    path: "/productService/history",
  },
];

apiList.value = [
  {
    title: "天气实况类",
    img: shikuang,
    content: [
      {
        name: "天气实况",
        path: "/dataProduct/0/00",
      },
      {
        name: "24小时（历史）天气实况",
        path: "/dataProduct/0/01",
      },
    ],
  },
  {
    title: "天气预报类",
    img: yubao,
    content: [
      {
        name: "短临预报",
        path: "/dataProduct/1/00",
      },
      {
        name: "逐小时预报",
        path: "/dataProduct/1/01",
      },
      {
        name: "逐日预报",
        path: "/dataProduct/1/02",
      },
      {
        name: "气候趋势预测",
        path: "/dataProduct/1/03",
      },
    ],
  },
  {
    title: "天气预警类",
    img: yujing,
    content: [
      {
        name: "城市天气预警",
        path: "/dataProduct/7/00",
      },
      {
        name: "全国天气预警",
        path: "/dataProduct/7/01",
      },
      {
        name: "地质灾害风险预警",
        path: "/dataProduct/7/02",
      },
      {
        name: "气象预警事件类型列表",
        path: "/dataProduct/7/04",
      },
    ],
  },
  {
    title: "空气质量类",
    img: kongzhi,
    content: [
      {
        name: "空气质量实况",
        path: "/dataProduct/13/00",
      },
      {
        name: "历史空气质量",
        path: "/dataProduct/13/01",
      },
      {
        name: "1天逐小时空气质量预报",
        path: "/dataProduct/13/02",
      },
      {
        name: "5天逐日空气质量预报",
        path: "/dataProduct/13/03",
      },
      {
        name: "空气质量实时排行",
        path: "/dataProduct/13/04",
      },
    ],
  },
  {
    title: "生活信息类",
    img: zhishu,
    content: [
      {
        name: "生活指数",
        path: "/dataProduct/11/00",
      },
      {
        name: "日出日落",
        path: "/dataProduct/11/01",
      },
      {
        name: "月出月落和月相",
        path: "/dataProduct/11/06",
      },
      {
        name: "尾号限行",
        path: "/dataProduct/11/03",
      },
    ],
  },
  {
    title: "海洋气象类",
    img: haiyang,
    content: [
      {
        name: "台风实况",
        path: "/dataProduct/6/00",
      },
      {
        name: "台风预报",
        path: "/dataProduct/6/01",
      },
      {
        name: "台风列表",
        path: "/dataProduct/6/02",
      },
      {
        name: "浪涌预报",
        path: "/dataProduct/6/04",
      },
      {
        name: "潮汐预报",
        path: "/dataProduct/6/05",
      },
    ],
  },
];

const getMsg = (index: number) => {
  cardIndex.value = index;
};

const go_api = (path: string) => {
  router.push(path);
};

return (_ctx: any,_cache: any) => {
  const _component_di = _resolveComponent("di")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(eSwitch, { moveWidth: 460 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scaleList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      style: {"text-align":"center","width":"180px"},
                      onClick: ($event: any) => (getMsg(index))
                    }, [
                      _createElementVNode("img", {
                        class: "_img",
                        src: cardIndex.value === index ? item.icon2 : item.icon,
                        alt: ""
                      }, null, 8, _hoisted_8),
                      _createElementVNode("p", {
                        class: _normalizeClass(cardIndex.value === index ? 'active' : '')
                      }, _toDisplayString(item.title), 3)
                    ], 8, _hoisted_7)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h3", _hoisted_10, _toDisplayString(scaleList.value[cardIndex.value].title), 1),
      _createElementVNode("p", _hoisted_11, _toDisplayString(scaleList.value[cardIndex.value].en), 1),
      (scaleList.value[cardIndex.value].en !== 'METEOROLOGICAL DATA')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(scaleList.value[cardIndex.value].msg), 1))
        : (_openBlock(), _createBlock(_component_di, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apiList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("p", _hoisted_14, [
                      _createElementVNode("img", {
                        class: "api_img",
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_15),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content, (item1, index1) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: index1,
                        onClick: ($event: any) => (go_api(item1.path)),
                        class: "api"
                      }, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(item1.name), 1)
                      ], 8, _hoisted_16))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })),
      (scaleList.value[cardIndex.value].en !== 'METEOROLOGICAL DATA')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: scaleList.value[cardIndex.value].path
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})